import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { useSensor } from './use_sensor';
export const Sensor = ({ onClickOutside, onEscape, children }) => {
    const ref = useRef(null);
    useSensor(onClickOutside, onEscape, ref);
    return (_jsx("div", { style: { display: 'inline-block' }, ref: ref, children: children }));
};
//# sourceMappingURL=sensor.js.map